import { FormInstance } from "antd";
import { useCallback } from "react";
import { useAppDispatch } from "../../../../../../../store";
import { updateLegal } from "../../../../../../../acions/accounts/legal";

export const useUpdateData = (
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>,
  form: FormInstance,
  contractId: string,
  reloadData: () => void
) => {
  const dispatch = useAppDispatch();

  const update = useCallback(async () => {
    try {
      setIsDisabled(true);

      const formData = await form.validateFields();

      await Promise.resolve(dispatch(updateLegal(contractId, formData)));

      reloadData();
    } catch (error) {
      setIsDisabled(false);
    }
  }, [dispatch, form, contractId, setIsDisabled, reloadData]);

  return { update };
};
